import styled from '@emotion/styled';
import { useEffect, useState } from 'react';


const OrderTable:React.FC<any> = ({ order }) => {
  const [ title, setTitle] = useState(""); 
  const photos = order.photos;

  const handleTitle = () => {
    if (order.product_name ==='gift') {
      setTitle('무료체험');
    } 
    else if(order.product_name === "BASIC" && order.order_state_id === 1 ) {
      setTitle(`${order.year}년 ${order.month}월의 받아볼 사진`);
    } 
    else {
      setTitle(`${order.year}년 ${order.month}월의 사진`)
    }
  }

  useEffect(() =>  {
    handleTitle();
  })
  return (
    <OrderContainer>
      <DateTable>
        {title}
      </DateTable>
      <PhotoContainer>
        <PhotoWrapper>
          <Img 
            src={photos[0]}
          />
        </PhotoWrapper>
        <PhotoWrapper>
          <Img 
            src={photos[1]}
          />
        </PhotoWrapper>
        <PhotoWrapper>
          <Img 
            src={photos[2]}
          />
        </PhotoWrapper>
        <PhotoWrapper>
          <Img 
            src={photos[3]}
          />
        </PhotoWrapper>
        <PhotoWrapper>
          <Img 
            src={photos[4]}
          />
        </PhotoWrapper>
      </PhotoContainer>
    </OrderContainer>
  )
}

export default OrderTable;

const OrderContainer = styled.div`
  width: 100%;
  height: 228px;
  margin-bottom: 52px;
  display: flex;
  flex-direction: column;
`;
const DateTable = styled.div`
  height: 26px;
  font-size: 20px;
`;
const PhotoContainer = styled.div`
  width: 100%;
  height: 167px;
  margin-top: 35px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const PhotoWrapper = styled.div`
  width: 167px;
  height: 167px;
  background-color: var(--light-grey);
`;
const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
const MonthlyText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  color: #444444;
  padding-left: 7px;
`;